import { render, staticRenderFns } from "./MainMenuJournal.vue?vue&type=template&id=bacf5ea8&scoped=true"
import script from "./MainMenuJournal.vue?vue&type=script&lang=js"
export * from "./MainMenuJournal.vue?vue&type=script&lang=js"
import style0 from "./MainMenuJournal.vue?vue&type=style&index=0&id=bacf5ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf5ea8",
  null
  
)

export default component.exports